<script lang="ts" setup>
const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    required: true,
  },
});

const documentId = inject("documentId") as any;

const thesaurusStore = useDocumentThesaurusStore(documentId);
const { underlinedWords } = storeToRefs(thesaurusStore);

const unclassifiedDressups = computed(() => {
  if (props.section.title.includes("Dress-Ups") == false) return [];

  if (underlinedWords.value.length == 0) return [];

  return underlinedWords.value.filter((word) => {
    return (
      Object.keys(word.attributes).some((attribute) => {
        return attribute.toLowerCase().includes("dressup");
      }) != true
    );
  });
});
</script>

<template>
  <div class="flex flex-col" v-auto-animate>
    <span class="mb-1 font-bold">
      {{ section.title }}
    </span>
    <div
      v-if="unclassifiedDressups.length > 0"
      class="flex flex-row gap-2 flex-wrap my-2"
    >
      <DocumentStudentEditingDressupsSelector
        v-for="dressUp in unclassifiedDressups"
        :key="dressUp.startIndex"
        :dress-up="dressUp"
      />
    </div>
    <div class="flex flex-col">
      <span class="mb-4">
        <ChecklistCriteria
          v-for="criteriaInstance in section.criteriaInstances"
          :key="criteriaInstance.checklistCriteriaId"
          :criteria-instance="criteriaInstance"
        />
      </span>
      <ChecklistSection
        v-for="(subSection, index) in section.sections"
        :key="index"
        :section="subSection"
        class=""
      />
    </div>
  </div>
</template>

<style scoped></style>
